export default __webpack_public_path__ + "static/media/chronos-fire.8086dc6b.svg";